<script>
/*eslint-disable */

import LoginDefault from '@/views/auth/default/login.vue'
import LoginCcnsw from '@/views/auth/ccnsw/login.vue'
import {appConfig} from "@/config";
import store from '../../store'

export default {
  components: { LoginDefault, LoginCcnsw },
  data () {
    return {
      host: '',
    }
  },
  methods: {},
  mounted () {
    this.host = window.location.hostname
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters.isStatewide) {
      document.location.replace(appConfig.statewideLandingUrl + '/');
    }
    next()
  },
  computed: {
    isCCNSW () {
      return (this.host == 'ccnsw.partssearch.com.au')
    },
    isDefault () {
      return !this.isCCNSW
    }
  }
}
</script>

<template>
  <login-ccnsw v-if="isCCNSW"></login-ccnsw>
  <login-default v-else></login-default>
</template>

